import { path } from 'ramda'
import React from 'react'

import { TO_USER } from '../_constants/assignConstants'
import { useCloneForm, useCloneFormActions } from '../_form/CloneServiceOrderForm'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import UsersSelect from '../../../../containers/users/select/UsersSelect'

const UserAssign = () => {
  const serviceOrder = useServiceOrder()
  const form = useCloneForm()
  const { handleChange } = useCloneFormActions()

  if (form.assign !== TO_USER) return false

  return (
    <UsersSelect
      selectedLabel={path(['user', 'name'], form)}
      onChange={(_, __, { origin }) => handleChange('user', origin)}
    />
  )
}

export default UserAssign
